<h1 mat-dialog-title>{{ "general.warning" | translate }}</h1>
<div mat-dialog-content>
	<p>{{ data.message | translate }}</p>
</div>

<div mat-dialog-actions>
	<button class="button" data-test="btn-cancel" [mat-dialog-close]="false">{{ "general.cancel" | translate }}</button>
	<button class="button accept" data-test="btn-add" [mat-dialog-close]="true">{{ "general.add" | translate }}</button>
</div>
